<template>
    <DsModal
        show-close
        :show-back="showTagCategoryForm"
        size="sm"
        class="create-tag-modal"
        :title="showTagCategoryForm ? $t('tags.addNewTagCategory') : $t('tags.addNewTag')"
        :is-open="isOpen"
        @close="$emit('close')"
        @back="showTagCategoryForm = false"
    >
        <template #header>
            <portal-target name="tagModalHeader" />
        </template>

        <template v-if="loaded" #default>
            <keep-alive>
                <CreateTagForm
                    v-if="!showTagCategoryForm"
                    :tag-name="tagName"
                    :tags="tags"
                    :tag-categories="tagCategories"
                    :new-category="newCategory"
                    @tagCreated="$emit('tagCreated', $event)"
                    @addNewCategory="showTagCategoryForm = true"
                />
            </keep-alive>

            <CreateTagCategoryForm
                v-if="showTagCategoryForm"
                :tag-categories="tagCategories"
                @categoryAdded="onNewTagCategoryAdded"
            />
        </template>
    </DsModal>
</template>

<script>
import CreateTagForm from './CreateTagForm.vue';
import CreateTagCategoryForm from './CreateTagCategoryForm.vue';
import { fetchTags, fetchTagCategories } from '@/api/tags';

export default {
    components: {
        CreateTagForm,
        CreateTagCategoryForm,
    },
    props: {
        isOpen: Boolean,
        tagName: String,
    },

    emits: ['close', 'tagCreated'],

    data() {
        return {
            showTagCategoryForm: false,
            tags: [],
            tagsLoaded: false,
            tagCategories: [],
            tagCategoriesLoaded: false,
            newCategory: null,
        };
    },

    watch: {
        isOpen: {
            handler(value) {
                if (value) {
                    this.loadTags();
                    this.loadTagCategories();
                } else {
                    this.reset();
                }
            },
            immediate: true,
        },
    },

    computed: {
        loaded() {
            return this.tagsLoaded && this.tagCategoriesLoaded;
        },
    },

    methods: {
        reset() {
            this.showTagCategoryForm = false;
            this.tags = [];
            this.tagsLoaded = false;
            this.tagCategories = [];
            this.tagCategoriesLoaded = false;
            this.newCategory = null;
        },

        async loadTags() {
            try {
                const tags = await fetchTags();

                this.tags = tags;
                this.tagsLoaded = true;
            } catch (e) {
                this.$error({ message: this.$t('tags.loadTagsError') });
            }
        },

        async loadTagCategories() {
            try {
                const tagCategories = await fetchTagCategories();

                this.tagCategories = tagCategories;
                this.tagCategoriesLoaded = true;
            } catch (e) {
                this.$error({ message: this.$t('tags.loadTagCategoriesError') });
            }
        },

        async onNewTagCategoryAdded(category) {
            await this.loadTagCategories();
            this.newCategory = category;
            this.showTagCategoryForm = false;
        },
    },
};
</script>

<style scoped lang="scss">
.create-tag-modal {
    --modal-overflow: overflow;
}

.create-tag-modal {
    :deep(.modal-content-wrapper),
    :deep(.modal-header),
    :deep(.modal-body) {
        border-radius: 0.75rem;
    }
}
</style>
